export const BLOCK_ANSWERED = 'BLOCK_ANSWERED';

function blockAnswered(blockId, answer, isValid) {
  return {
    type: BLOCK_ANSWERED,
    blockId,
    answer,
    isValid
  };
}

export function answerBlock(blockId, answer, isValid) {
  return (dispatch) => {
    dispatch(blockAnswered(blockId, answer, isValid));
  };
}
